import { z } from 'zod';

export type DateTimeType = z.infer<typeof DateTimeType>;
export type PlainDateType = z.infer<typeof PlainDateType>;
export type PlainDateRange = [PlainDateType, PlainDateType];
export type PlainTimeType = `${number}:${number}:${number}` | `${number}:${number}`;
export type PlainDateTimeType =
    `${number}-${number}-${number}${'T' | ''}${number}:${number}:${number}`;

export const DateTimeType = z
    .union([z.string(), z.date()])
    .transform((value) => (typeof value === 'string' ? value : (value as any).toISOString()))
    .refine((value) => value.match(/^\d+-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?Z$/) !== null)
    .transform(
        (value) =>
            value as `${number}-${number}-${number}T${number}:${number}:${number}${`.${number}` | ''}Z`,
    );

export const PlainDateType = z
    .union([z.string(), z.date()])
    .transform((value) => (typeof value === 'string' ? value : value.toISOString()))
    .refine((value) => value.match(/^\d+-\d{2}-\d{2}/))
    .transform((value) => value.match(/^(\d+-\d{2}-\d{2})/)![1] as `${number}-${number}-${number}`);
